import { gql } from '@apollo/client'

import { editFragment } from 'js/magazine-issue/lib/fragments'

export const GET_ISSUE_EDIT = gql`
    query MagazineIssueEdit($guid: String!) {
        entity(guid: $guid) {
            guid
            ${editFragment}
        }
    }
`
